// --- (1), (2) & (3): install and import ---
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
// --- ---------------------------------- ---

export function Map() {
  // Berlin coordinates
  const position = [50.49, 30.45];
  const center = [48.87, 31.26];

  // --- (6) Create a custom marker ---
  const customIcon = new Icon({
    iconUrl: 'radioactive.svg',
    iconSize: [33, 33],
    // iconAnchor: [1, 1],
    // popupAnchor: [-0, -76]
  })

  return (
    <section className='map-component' >
      {/* --- (5) Add leaflet map container --- */}
      <div className='map'>
      <MapContainer center={center} zoom={7} scrollWheelZoom={true}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          // --- (7) Alternative map style (attribution and url copied from the leaflet extras website) ---
          // attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
          // url='https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png'
          // --- -------------------------------------------------------------------------------------- ---
        />
        <Marker position={position}
          icon={customIcon}
        >
          <Popup>
            Результат заміру: 14мкР/г <br/>
            Тип заміру: гамма <br/>
            Місце: Київ, Куренівка<br/>
            Час: 20:30 07.06.2023<br/>
            Дозиметр: Радіаскан з СБТ10а і гамма фільтром<br/>
            Сертифікація: відсутня
          </Popup>
          <Tooltip>
            14мкР/г <br/>
            Детальніша інформація по кліку
          </Tooltip>
        </Marker>
      </MapContainer>
      {/* --- ---------------------------- --- */}
      </div>
    </section>
  )
}